import { Component } from '@theme/component';

// Presentation only: Essential Upsell owns selection, pricing and cart submission.
class UnboundBundleOffer extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.start();
  }

  updatedCallback() {
    super.updatedCallback();
    this.start();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.stop();
  }

  stop() {
    this.observer?.disconnect();
    this.controller?.abort();
    cancelAnimationFrame(this.frame);
  }

  start() {
    this.stop();
    this.root = this.closest('.unbound-complete-look');
    if (!this.root) return;
    this.controller = new AbortController();
    this.variantImages = new Map([...this.querySelector('template[data-bundle-images]')?.content.querySelectorAll('[data-variant]') || []]
      .map(node => [node.dataset.variant, { src: node.dataset.src, alt: node.dataset.alt }]));
    this.root.addEventListener('change', this.schedule, { signal: this.controller.signal });
    this.observer = new MutationObserver(this.schedule);
    this.observer.observe(this.root, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['checked', 'disabled', 'data-discounted-price-value', 'data-regular-price-value', 'data-variant-id', 'src', 'srcset']
    });
    this.schedule();
  }

  schedule = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.updateOffer());
  };

  write(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  updateOffer() {
    if (!this.isConnected || !this.root) return;
    const app = this.root.querySelector('essential-upsell-frequently-bought-together-app-block');
    const container = app?.querySelector('[data-essential-upsell-funnel-id]');
    const rows = [...(container?.querySelectorAll('[data-essential-upsell-element="product"]') || [])];
    for (const row of rows) {
      const variantId = row.querySelector('select')?.value || row.querySelector('[data-variant-id]')?.dataset.variantId;
      const source = this.variantImages.get(variantId);
      const image = row.querySelector('img[data-essential-upsell-element="image"]');
      if (source?.src && image) {
        if (image.getAttribute('src') !== source.src) image.setAttribute('src', source.src);
        if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
        if (image.alt !== source.alt) image.alt = source.alt;
      }
    }
    const selected = rows.filter(row => row.querySelector('input[type="checkbox"]')?.checked);
    const currency = app?.getAttribute('presentment-currency');
    const money = (cents, decimals = 0) => {
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: decimals, maximumFractionDigits: 2
      }).format(cents / 100);
      return currency === 'AED' ? `Dhs${amount}` : `${currency} ${amount}`;
    };
    let regular = 0;
    let discounted = 0;
    let valid = selected.length > 0 && /^[A-Z]{3}$/.test(currency || '');
    for (const row of selected) {
      const saleNode = row.querySelector('[data-discounted-price-value]');
      const regularNode = row.querySelector('[data-regular-price-value]');
      const sale = Number(saleNode?.getAttribute('data-discounted-price-value'));
      const full = regularNode ? Number(regularNode.getAttribute('data-regular-price-value')) : sale;
      if (!saleNode || !Number.isFinite(sale) || !Number.isFinite(full) || sale < 0 || full < sale) valid = false;
      discounted += Math.round(sale * 100);
      regular += Math.round(full * 100);
    }
    const saving = regular - discounted;
    const isSet = valid && selected.length > 1;
    this.root.classList.toggle('unbound-bundle-enhanced', Boolean(rows.length));
    this.root.classList.toggle('unbound-bundle-single', valid && selected.length < 2);
    this.write(this.refs.title, isSet && saving > 0
      ? this.dataset.saving.replace('__percent__', new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 }).format(Math.floor(saving / regular * 1000) / 10)) : this.dataset.fallback);
    this.write(this.refs.hint, isSet
      ? this.dataset.pieces.replace('__count__', selected.length) : this.dataset.choose);
    const missingSizes = isSet && selected.some(row => {
      const select = row.querySelector('select');
      return select?.options.length > 1 && [...select.options].some(option => option.disabled && option.value);
    });
    if (this.refs.availability) this.refs.availability.hidden = !missingSizes;

    const button = container?.querySelector('[data-essential-upsell-element="add-to-cart-button"]');
    if (button && (!button.disabled || !isSet) && valid) {
      // Preserve the app's icon, price nodes, events and loading state.
      const label = [...button.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      const text = (selected.length > 1 ? this.dataset.addPieces.replace('__count__', selected.length) : this.dataset.addOne) + ' ';
      if (label && label.textContent !== text) label.textContent = text;
    }
    const payment = this.root.querySelector('[data-bundle-payment]');
    const paymentText = valid && currency === 'AED'
      ? this.dataset.payment.replace('__amount__', money(Math.round(discounted / 4), 2))
      : this.dataset.paymentFallback;
    this.write(payment, paymentText);
  }
}

if (!customElements.get('unbound-bundle-offer')) {
  customElements.define('unbound-bundle-offer', UnboundBundleOffer);
}

